import React, { useState, useEffect } from 'react';
import {
  Typography,
  Box,
  TextField,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import { StepProps } from './types';
import { StepButtonBar } from './StepButtonBar';
import OtherRequirementInfo from './OtherRequirementInfo';

interface Step2BasicInfoProps extends StepProps {
  otherRequirementInfo: any;
  setOtherRequirementInfo: (any) => void;
  currentStepName: string;
}

const Step2BasicInfo: React.FC<Step2BasicInfoProps> = ({
  onNext,
  onBack,
  onCancel,
  currentData,
  isFirstStep,
  otherRequirementInfo,
  setOtherRequirementInfo,
  currentStepName
}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);

  const [name, setName] = useState(currentData.name || '');

  useEffect(() => {
    if (currentData.name) {
      setName(currentData.name);
    }
  }, [currentData.name]);

  const handleNext = () => {
    if (name.trim()) {
      onNext({
        name: name.trim(),
      });
    }
  };

  const isValid = name.trim();

  return (
    <Box style={{ width: '100%' }}>
      <Box
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <Box
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '400px',
          }}
        >
          <Box style={{ maxWidth: '320px', width: '100%' }}>
            {/* Name Field */}
            <Box style={{ marginBottom: theme.spacing(2) }}>
              {/* <Typography
                variant="body2"
                style={{
                  fontWeight: 600,
                  marginBottom: '4px',
                  fontSize: '14px',
                }}
              >
                {formatMessage({
                  id: 'law-portal.manage.requirements.nameRequirement',
                  defaultMessage: 'Name the requirement',
                })}
                {' '}
                <span style={{ color: 'red' }}>*</span>
              </Typography> */}
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={formatMessage({
                  id: 'law-portal.manage.requirements.nameRequirement',
                  defaultMessage: 'Name the requirement',
                })}
              />
            </Box>
          </Box>
        </Box>

        <OtherRequirementInfo otherRequirementStepInfo={otherRequirementInfo} currentStepName={currentStepName} onUpdate={setOtherRequirementInfo} />
      </Box>

      <StepButtonBar
        onCancel={onCancel}
        onBack={onBack}
        onNext={handleNext}
        nextLabel="form.next"
        nextDisabled={!isValid}
        formatMessage={formatMessage}
        showBack={true}
      />
    </Box>
  );
};

export default Step2BasicInfo;
